import { render, staticRenderFns } from "./BookingErrorPopup.vue?vue&type=template&id=18c10467&scoped=true"
import script from "./BookingErrorPopup.vue?vue&type=script&lang=js"
export * from "./BookingErrorPopup.vue?vue&type=script&lang=js"
import style0 from "./BookingErrorPopup.vue?vue&type=style&index=0&id=18c10467&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c10467",
  null
  
)

export default component.exports